import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const consentsDetailedStyle = StyleSheet.create({
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'black',
        justifyContent: 'center'
    },
    webContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        paddingTop: 30
    },
    scrolableContainer: {
        flexGrow: 1,
        paddingTop: 20
    },
    postedCOnsentsFromSettingContainer: {
        backgroundColor: 'rgba(0, 0, 0,1)',
        flex: 1,
        alignItems: 'center'
    },
    infoPageContainer: {
        flex: 1
        // justifyContent: 'center'
    },
    consentsWidthOnWebSettings: {
        width: '70%'
    },
    consentsWidthOnWebModal: {
        width: '95%'
    },
    confitmClosebutton: {
        width: Device.isPhone ? '80%' : '30%'
    },
    safeAreaContainer: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        paddingBottom: 16,
        paddingHorizontal: 16,
        paddingTop: 8
    },
    text: {
        fontSize: 18,
        color: '#FCFCFC',
        textAlign: 'center',
        marginBottom: 10,
        fontFamily: Theme.regularFont,
        paddingVertical: 8
    },
    title: {
        fontSize: 26,
        textAlign: 'center',
        color: 'white',
        fontFamily: Theme.regularFont,
        marginBottom: 10,
        lineHeight: 34,
        paddingVertical: 8
    },
    titleWeb: {
        fontSize: 25,
        textAlign: 'center',
        color: 'white',
        fontFamily: Theme.regularFont,
        lineHeight: 34,
        paddingTop: 8
    },
    textWeb: {
        fontSize: 18,
        color: '#FCFCFC',
        textAlign: 'center',
        marginBottom: 10,
        fontFamily: Theme.regularFont,
        paddingVertical: 8
    },
    alignTitleAndTextWeb: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
    },
    buttonSelectedAllMobile: {
        alignItems: 'center',
        backgroundColor: 'rgba(252, 252, 252, 0.15)',
        height: 60,
        justifyContent: 'space-between',
        flexDirection: 'row'
    },
    buttonSelectAllMobile: {
        alignItems: 'center',
        backgroundColor: '#E20074',
        height: 60,
        justifyContent: 'space-between',
        flexDirection: 'row'
    },
    buttonSelectedAllWeb: {
        alignItems: 'center',
        backgroundColor: 'rgba(252, 252, 252, 0.15)',
        height: 60,
        justifyContent: 'space-between',
        flexDirection: 'row',
        borderRadius: 3,
        borderColor: 'rgba(252, 252, 252, 0.3)',
        borderWidth: 1
    },
    buttonSelectAllWeb: {
        backgroundColor: '#E20074',
        alignItems: 'center',
        height: 60,
        justifyContent: 'space-between',
        flexDirection: 'row',
        borderRadius: 3
    },
    buttonText: {
        paddingLeft: 20,
        fontSize: 20,
        color: 'white'
    },
    acceptButtonText: {
        fontSize: 20,
        color: 'white',
        fontFamily: Theme.thinFont
    },
    alignToRow: { flexDirection: 'row', paddingRight: 20 },
    acceotAllButtonAdditionalStyle: {
        textAlign: 'center'
    },
    acceptSelected: {
        backgroundColor: Theme.primaryButtonBackgroundColor,
        paddingHorizontal: 20,
        paddingVertical: 10,
        borderRadius: 3,
        marginBottom: 20,
        height: 60
    },
    alignToRight: {
        alignSelf: 'flex-end'
    },
    checkBox: {
        paddingEnd: 20
    },
    gradientOverlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 80
    },
    dividerStyle: {
        borderBottomColor: 'gray',
        borderBottomWidth: 1,
        marginVertical: 16
    },
    backIcon: { width: 29, height: 29, marginStart: Device.isWeb ? 0 : 11 },

    bottomButtonPadding: {
        paddingBottom: 40,
        paddingTop: 30
    },
    spacing20: {
        height: 20
    }
});

export default consentsDetailedStyle;
